import React from 'react'
import PropTypes from 'prop-types'
import ParticlesOverlay from 'components/LayoutComponents/ParticlesOverlay'
import { useTranslate } from 'services/utils'
import { Button } from 'antd'
import PageLoader from 'components/GeneralComponents/Loaders/PageLoader'

const PageNotice = ({ loading, id = 'error', onClick, action }) => {
  const translate = useTranslate()
  return (
    <ParticlesOverlay>
      <main className="container minimal-spacing align-self-center">
        <div className="row p-3 mb-5">
          <div className="col">
            <div className="text-center">
              <div className="w-50 d-inline-block pt-5 pb-5 mt-5 mb-5">
                <h1 className="mb-4">{translate(`pageNotice.${id}`)}</h1>
                {action && (
                  <Button size="large" onClick={onClick}>
                    {translate(`pageNotice.${action}`)}
                  </Button>
                )}
                {loading && <PageLoader />}
              </div>
            </div>
          </div>
        </div>
      </main>
    </ParticlesOverlay>
  )
}

PageNotice.defaultProps = {
  onClick: undefined,
  action: null,
  loading: false,
}

PageNotice.propTypes = {
  id: PropTypes.string.isRequired,
  action: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
}

export default PageNotice
